import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const SecurityLock = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C15.833 30 15.665 29.958 15.514 29.874C15.125 29.658 6 24.513 6 18V7C6 4.243 8.243 2 11 2H21C23.757 2 26 4.243 26 7V18C26 24.514 16.874 29.658 16.486 29.874C16.335 29.958 16.168 30 16 30V30ZM11 4C9.346 4 8 5.346 8 7V18C8 20.728 10.265 23.314 12.164 25.003C13.698 26.367 15.239 27.372 15.999 27.838C16.765 27.368 18.324 26.35 19.862 24.979C21.75 23.296 23.999 20.719 23.999 18V7C23.999 5.346 22.653 4 20.999 4H10.999H11Z" />
		<path d="M20 12.172V12C20 9.794 18.206 8 16 8C13.794 8 12 9.794 12 12V12.172C10.836 12.585 10 13.696 10 15V17C10 18.654 11.346 20 13 20H19C20.654 20 22 18.654 22 17V15C22 13.696 21.164 12.585 20 12.172ZM16 10C17.103 10 18 10.897 18 12H14C14 10.897 14.897 10 16 10ZM20 17C20 17.551 19.551 18 19 18H13C12.449 18 12 17.551 12 17V15C12 14.449 12.449 14 13 14H19C19.551 14 20 14.449 20 15V17Z" />
	</svg>
);

export default SecurityLock;
